import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ChannelConfigStepper } from './ChannelConfigStepper';

import * as actions from '../actions/index'

export class AEmailStepper extends Component {

  static propTypes = {
    channel: PropTypes.object,
    channelType: PropTypes.string.isRequired,
    fetchChannelProviders: PropTypes.func.isRequired,
    channelAPI: PropTypes.func.isRequired,
    createChannel: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
    addingChannel: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired
  }

  constructor(props,context) {
    super(props,context);

    this.state = {
      providerId: null,
    }

    this.handleNextStep = this.handleNextStep.bind(this);
  }

  componentWillMount() {
    if (this.props.addingChannel) {
      this.props.fetchChannelProviders((response, err) => {
        if (!err) {
          if ( response.length !== 0 ) {
            const providerId = response[0].id
            this.setState({providerId})
          }
          else {
            this.props.dispatch(actions.setMessage('Provider Not Found'))
          }
        }
      })
    }
  }

  handleNextStep() {
    const step = this.channelConfigStepper.stepper.state.activeStep

    if (step === 1) {
      this.nextStep()
    }
    else if (step === 2) {
      if (this.props.addingChannel) {
        this.save()
      }
      else {
        this.nextStep()
      }
    }
  }

  nextStep() {
    if (this.channelConfigStepper.isLastStep()) {
      this.props.goBack()
    }
    else {
      this.channelConfigStepper.stepper.nextStep()
    }
  }

  save(){
    const { state } = this.channelConfigStepper

    let newChannel = {enabled: true}
    newChannel.provider = `${this.state.providerId}-${state.params.email}` 
    newChannel.params = {
      "email": state.params.email
    }

    if (state.params.signature) {
      newChannel.params["signature"] = state.params.signature
    }

    this.props.createChannel(newChannel, (response, err) => {
      if (!err) {
        this.nextStep()
      }
    })
  }

  render(){
    const { channel, channelType } = this.props
    return (
      <div>
        <ChannelConfigStepper ref={(s) => this.channelConfigStepper = s} channelType={channelType} channel={channel} onBeforeNextStep={this.handleNextStep}/>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/containers/AEmailStepper.js